import React from 'react';
import styled from 'styled-components';
import { formatPercentage } from '../utils';

interface MainProgressBarProps {
  percentage: number;
  label: string;
  level: number;
  total: string;
  burned: string;
  maxLevel: number;
}

const Container = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 30px 0;

  /* Mobile responsiveness */
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 15px; /* Adjust padding for mobile */
  }
`;

const Label = styled.div<{ right?: boolean }>`
  font-size: 1.4rem;
  font-weight: bold;
  color: #fff;
  display: ${({ right }) => (right ? 'block' : 'flex')};
  justify-content: space-between;
  text-align: ${({ right }) => (right ? 'right' : 'left')};
  width: 100%;
  margin-bottom: 10px;

  /* Mobile responsiveness */
  @media (max-width: 768px) {
    font-size: 1.2rem;
    margin-bottom: 8px;
  }
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 45px;
  background-color: #1a202c;
  border-radius: 15px;
  overflow: hidden;
  border: 2px solid #9840eb;
  position: relative;
  margin-bottom: 15px;

  /* Mobile responsiveness */
  @media (max-width: 768px) {
    height: 35px;
  }
`;

const Progress = styled.div<{ percentage: number }>`
  width: ${({ percentage }) => percentage}%;
  height: 100%;
  background: linear-gradient(90deg, #9840eb, rgb(147, 42, 245));
  transition: width 0.5s ease;
  position: relative;
`;

const PercentageText = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-weight: bold;
  font-size: 1.4rem;

  /* Mobile responsiveness */
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const LevelIndicator = styled.span`
  color: #ffd700;
  font-size: 1.4rem;

  /* Mobile responsiveness */
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const MainProgressBar: React.FC<MainProgressBarProps> = ({
  percentage,
  label,
  burned,
  level,
  total,
  maxLevel,
}) => {
  return (
    <Container>
      <Label>
        {label}
        <LevelIndicator>
          Level {level} / {maxLevel}
        </LevelIndicator>
      </Label>
      <ProgressBarContainer>
        <Progress percentage={percentage} />
        <PercentageText>{formatPercentage(percentage)}</PercentageText>
      </ProgressBarContainer>
      <Label right>
        {burned.toLocaleString()} / {total.toLocaleString()}
      </Label>
    </Container>
  );
};

export default MainProgressBar;
